import { MonthlyFragmentationReport as _MonthlyFragmentationReport } from '../../../shared-models/public/monthly-fragmentation-report';

export class MonthlyFragmentationReport extends _MonthlyFragmentationReport {
}

export namespace MonthlyFragmentationReport {
	export import RestTypes = _MonthlyFragmentationReport.RestTypes;
}
